
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChevronUpGoogle as ObiChevronUpGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chevron-up-google.js';
 
 
 

 
 export const ObiChevronUpGoogle = createComponent({
   react: React,
   tagName: 'obi-chevron-up-google',
   elementClass: ObiChevronUpGoogleElement,
   events: {
     
   }
  });
 
 